import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import DOMPurify from 'dompurify';

export class ModalAlerteOptions {
	public title?: string = "Attention !"
	public message?: string = undefined;
	// eslint-disable-next-line @typescript-eslint/ban-types
	public callBackYes?: Function = undefined;
	// eslint-disable-next-line @typescript-eslint/ban-types
	public callBackNo?: Function = undefined;
	public canClose = true;
	public showDialog = false;
	public yesText?: string = "VALIDER";
	public noText?: string = "ANNULER";
	public closeAutoWhenValidated = true;
	public isBooleanChoiceVisible: boolean = false;
	public booleanChoiceText: string = "";
	public modalClass?: string = undefined;

	public constructor(init?: Partial<ModalAlerteOptions>) {
    	(<any>Object).assign(this, init);
	}
}

@Component
export default class ModalAlerte extends Vue {
	public canClose = false;
	public modalClass?: string = undefined;
	public message?: string = undefined;
	public title?: string = "Attention !"
	public isYesVisible = true;
	// eslint-disable-next-line @typescript-eslint/ban-types
	public callBackYes?: Function;
	public isNoVisible = true;
	// eslint-disable-next-line @typescript-eslint/ban-types
	public callBackNo?: Function;
	public yesText?: string = "VALIDER";
	public noText?: string = "ANNULER";
	public closeAutoWhenValidated = true;
	public isLoadingAnimationVisible = false;
	public isFirstInit = true;
	public isBooleanChoiceVisible: boolean = false;
	public booleanChoiceText: string = "";
	public booleanChoiceValue: boolean = false;


	public init(options: ModalAlerteOptions): void {
		this.message = DOMPurify.sanitize(options.message??"");
    	this.canClose = options.canClose;
    	this.callBackYes = options.callBackYes;
    	this.isYesVisible = this.callBackYes != undefined;
    	this.callBackNo = options.callBackNo;
    	this.isNoVisible = this.callBackNo != undefined;
    	this.title = options.title;
    	this.yesText = options.yesText;
    	this.noText = options.noText;
		this.closeAutoWhenValidated = options.closeAutoWhenValidated;
		this.isBooleanChoiceVisible = options.isBooleanChoiceVisible;
		this.booleanChoiceText = options.booleanChoiceText;
		this.booleanChoiceValue = false;
		this.$forceUpdate();
		this.modalClass = options.modalClass;

    	const timeDelay = (this.isFirstInit) ? 0 : 500;
    	setTimeout(function() {
    		if (options.showDialog) {
				$("#modalAlerte").modal({ backdrop: "static" });
			} else {
				$("#modalAlerte").modal("show");
			}
    	}, timeDelay);
    	this.isFirstInit = false;
	}

	public valider(): void {
    	if (this.callBackYes != undefined) {
			this.callBackYes(this);
		}
    	if (this.closeAutoWhenValidated == true) {
			this.closeModal();
		}
	}

	public displayLoadingAnimation(shouldDisplay: boolean): void {
    	this.isLoadingAnimationVisible = shouldDisplay;
	}

	public closeModal(): void {
    	this.displayLoadingAnimation(false);
    	$("#modalAlerte").modal("hide");
	}

	public annuler(): void {
    	if (this.callBackNo != undefined) {
			this.callBackNo();
		}
    	this.closeModal();
	}

	public toggleBooleanChoice(): void {
		this.booleanChoiceValue = !this.booleanChoiceValue;
	}
}




// WEBPACK FOOTER //
// ./src/components/modalComponents/modalAlerte/modalAlerte.ts